function MemberWalletLogModel(BaseModel) {
    'ngInject';

    class Member_WalletLog extends BaseModel {
        constructor(data) {
            super(data);

            this.created_at = moment(this.created_at);

            // HACK - if payment amount is less than zero, API returns it as zero!
            this.payment_amount = parseFloat(this.amount) * 100;

            // HACK - new wallet amount should be returned as a integer
            this.new_wallet_amount = parseFloat(this.new_wallet_amount) * 100;
        }
    }

    return Member_WalletLog;
}

angular
    .module('BB')
    .service('Member.WalletLogModel', MemberWalletLogModel);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/_models/member_wallet_log_model.service.js